import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = { class: "user-info-name" }
const _hoisted_3 = {
  key: 0,
  class: "balance"
}

import store from '@/store'
import { computed } from 'vue'
import { can } from '@/helpers/utils'
import { formatUsdt } from '@/helpers/format'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {


const balanceFormatted = computed(() => formatUsdt(store.state.balance))
const name = computed(() => store.state.user?.name)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(name.value), 1),
    _createElementVNode("div", null, [
      (_unref(can)('USDT_ACCOUNT'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(balanceFormatted.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})